module.exports = __webpack_public_path__ + "img/logo-fill.d25c9ac0.png";